/**
 * Módulo que maneja todos los controles del grabador:
 * - Botones de iniciar, pausar, reanudar, detener, volver a grabar y adjuntar
 * - Lógica del MediaRecorder
 * - Overlay visual y loader durante subida al CKEditor
 */

function releaseMicAndCamera() {
    try {
        if (window._mediaPipeCamera) {
            try { window._mediaPipeCamera.stop(); } catch { }
            delete window._mediaPipeCamera;
        }
        // if (window._selfieSegmentation) {
        //     try { window._selfieSegmentation.close(); } catch { }
        //     delete window._selfieSegmentation;
        // }

        const allStreams = [window._activeRecorderStream, window._canvasRecorderStream];
        allStreams.forEach(stream => {
            if (stream && typeof stream.getTracks === 'function') {
                stream.getTracks().forEach(track => { try { track.stop(); } catch { } });
            }
        });

        document.querySelectorAll('video, audio').forEach(el => {
            try {
                if (el.srcObject) {
                    el.srcObject.getTracks().forEach(track => track.stop());
                    el.srcObject = null;
                }
                el.removeAttribute('src');
                el.load();
            } catch { }
        });

        if (window._voiceAnalyzer && window._voiceAnalyzer.context) {
            try {
                const ctx = window._voiceAnalyzer.context;
                if (ctx.state !== 'closed') ctx.close();
            } catch { }
            delete window._voiceAnalyzer;
        }

        delete window._activeRecorderStream;
        delete window._canvasRecorderStream;
        delete window._activeVideoElement;
    } catch (err) {
        console.error('Error al liberar micrófono/cámara:', err);
    }
}

function forceReleaseMic() {
    try {
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(tempStream => {
                try { tempStream.getTracks().forEach(track => track.stop()); } catch { }
            })
            .catch(() => { });
    } catch { }
}

export function setupControls({
    type,
    modal,
    previewArea,
    onAttach,
    fpoptions,
    loadSelfieSegmentationLibs,
    uploadRecording,
    closeModal
}) {
    const buttonsContainer = document.getElementById('recorderButtonsContainer');
    buttonsContainer.innerHTML = `
        <button id="startRecordingBtn" class="btn btn-primary" disabled>
            <i class="fas fa-play icon"></i><span>Grabar</span>
        </button>
        <button id="resumeRecordingBtn" class="btn btn-primary" disabled style="margin-left:0.5rem!important;">
            <i class="fas fa-play icon"></i><span>Reanudar</span>
        </button>
        <button id="pauseRecordingBtn" class="btn btn-secondary" disabled style="margin-left:0.5rem!important;">
            <i class="fas fa-pause icon"></i><span>Pausar</span>
        </button>
        <button id="stopRecordingBtn" class="btn btn-secondary" disabled style="margin-left:0.5rem!important;">
            <i class="fas fa-stop icon"></i><span>Finalizar</span>
        </button>
        <button id="redoRecordingBtn" class="btn btn-secondary" disabled style="margin-left:0.5rem!important;">
            <i class="fas fa-redo icon"></i><span>Volver a grabar</span>
        </button>
        <button id="attachRecordingBtn" class="btn btn-primary" disabled style="margin-left:0.5rem!important;position:relative;">
            <i class="fas fa-paperclip icon"></i><span>Adjuntar</span>
        </button>
    `;

    const startBtn = document.getElementById('startRecordingBtn');
    const resumeBtn = document.getElementById('resumeRecordingBtn');
    const stopBtn = document.getElementById('stopRecordingBtn');
    const pauseBtn = document.getElementById('pauseRecordingBtn');
    const attachBtn = document.getElementById('attachRecordingBtn');
    const redoBtn = document.getElementById('redoRecordingBtn');
    const closeBtn = document.getElementById('closeRecordingBtn');

    function toggleDeviceSelectors(disabled) {
        const camSelect = document.getElementById("camSelect");
        const micSelect = document.getElementById("micSelect");
        [camSelect, micSelect].forEach(sel => {
            if (sel) {
                sel.disabled = disabled;
                sel.style.opacity = disabled ? "0.6" : "1";
                sel.style.pointerEvents = disabled ? "none" : "auto";
            }
        });
    }

    let recorder, chunks = [], blob, url;
    let indicator = null;
    let indicatorText = null;
    let indicatorTime = null;
    let elapsedSeconds = 0, timerInterval;

    const stream = window._activeRecorderStream || null;

    function setVisibleButtons(...ids) {
        const all = [startBtn, resumeBtn, pauseBtn, stopBtn, redoBtn, attachBtn];
        all.forEach(btn => btn && (btn.style.display = 'none'));
        ids.forEach(btn => btn && (btn.style.display = 'inline-block'));
    }

    startBtn.disabled = false;
    setVisibleButtons(startBtn);

    // --- Iniciar grabación ---
    startBtn.onclick = () => {
        if (typeof window._showCountdownOverlay === 'function') {
            window._showCountdownOverlay(3, () => {
                if (typeof window._startRecordingOverlay === 'function') window._startRecordingOverlay();
                startRecordingNow();
            });
        } else {
            if (typeof window._startRecordingOverlay === 'function') window._startRecordingOverlay();
            startRecordingNow();
        }
    };

    function startRecordingNow() {
        indicator = document.getElementById('recordingIndicator');
        if (indicator) {
            indicator.innerHTML = `
                <div style="display:flex;align-items:center;gap:6px;">
                    <div class="record-dot" 
                        style="width:10px;height:10px;border-radius:50%;background:red;animation:blinkDot 1s infinite;">
                    </div>
                    <span id="indicatorText" style="font-weight:600;">Grabando</span>
                    <span id="indicatorTime" style="margin-left:4px;">00:00</span>
                </div>
                <style>
                    @keyframes blinkDot {
                        0%, 50%, 100% { opacity: 1; }
                        25%, 75% { opacity: 0; }
                    }
                </style>
            `;
            indicator.style.display = 'flex';
            indicatorText = indicator.querySelector('#indicatorText');
            indicatorTime = indicator.querySelector('#indicatorTime');
        }

        let recordingStream;

        if (type === 'video') {
            // const segmentedCanvas = document.getElementById('segmentedCanvas');
            const previewVideo = document.getElementById('previewVideo');

            // Crear un canvas combinado que SIEMPRE esté activo
            const finalCanvas = document.createElement('canvas');
            const finalCtx = finalCanvas.getContext('2d');

            // Configurar dimensiones del video
            const setCanvasDimensions = () => {
                if (previewVideo.videoWidth && previewVideo.videoHeight) {
                    finalCanvas.width = previewVideo.videoWidth;
                    finalCanvas.height = previewVideo.videoHeight;
                    return true;
                }
                // Usar dimensiones por defecto
                finalCanvas.width = 1280;
                finalCanvas.height = 720;
                return false;
            };

            setCanvasDimensions();
            // Función que actualiza el canvas en cada frame
            let animationId;
            const updateCanvas = () => {
                // Si el canvas de segmentación está visible, usar ese
                // if (segmentedCanvas && segmentedCanvas.style.display !== 'none') {
                //     finalCtx.drawImage(segmentedCanvas, 0, 0, finalCanvas.width, finalCanvas.height);
                // }
                // // Si no, usar el video directamente
                // else {
                    finalCtx.drawImage(previewVideo, 0, 0, finalCanvas.width, finalCanvas.height);
                // }

                animationId = requestAnimationFrame(updateCanvas);
            };

            updateCanvas();

            // Capturar el stream del canvas combinado
            const canvasStream = finalCanvas.captureStream(30);

            const currentAudioTracks = window._activeRecorderStream?.getAudioTracks() || [];

            currentAudioTracks.forEach(track => {
                canvasStream.addTrack(track);
            });

            // Guardar referencias para limpieza
            window._canvasRecorderStream = canvasStream;
            window._finalCanvas = finalCanvas;
            window._canvasAnimationId = animationId;
            recordingStream = canvasStream;
        } else {
            recordingStream = window._activeRecorderStream;
        }

        recorder = new MediaRecorder(recordingStream, {
            mimeType: type === 'audio' ? 'audio/webm' : 'video/webm',
            videoBitsPerSecond: 2500000
        });

        chunks = [];

        recorder.ondataavailable = e => chunks.push(e.data);

        recorder.onstop = () => {
            blob = new Blob(chunks, { type: type === 'audio' ? 'audio/ogg' : 'video/webm' });
            url = URL.createObjectURL(blob);
            clearInterval(timerInterval);

            // Detener la animación del canvas
            if (window._canvasAnimationId) {
                cancelAnimationFrame(window._canvasAnimationId);
                delete window._canvasAnimationId;
            }

            if (indicator) indicator.style.display = 'none';
            if (typeof window._stopRecordingOverlay === 'function') window._stopRecordingOverlay();

            // --- Vista previa ---
            if (type === 'audio') {
                previewArea.innerHTML = `<audio controls style="width:100%;"><source src="${url}" type="${blob.type}"></audio>`;
            } else {
                previewArea.innerHTML = `
                <video controls style="width:100%;height:auto;border-radius:5px;">
                    <source src="${url}" type="${blob.type}">
                </video>`;
            }

            attachBtn.disabled = false;
            resumeBtn.disabled = false;
            redoBtn.disabled = false;
            startBtn.disabled = true;
            stopBtn.disabled = true;
            pauseBtn.disabled = true;
            setVisibleButtons(redoBtn, attachBtn);
        };

        recorder.start();
        window._activeRecorder = recorder;
        toggleDeviceSelectors(true);

        setVisibleButtons(pauseBtn, stopBtn);
        resumeBtn.disabled = false;
        stopBtn.disabled = false;
        pauseBtn.disabled = false;
        attachBtn.disabled = true;
        redoBtn.disabled = true;

        // --- Cronómetro visual interno (solo para overlay)
        elapsedSeconds = 0;
        timerInterval = setInterval(() => {
            elapsedSeconds++;
            const m = String(Math.floor(elapsedSeconds / 60)).padStart(2, '0');
            const s = String(elapsedSeconds % 60).padStart(2, '0');
            if (indicatorTime) indicatorTime.textContent = `${m}:${s}`;
        }, 1000);
    }

    function stopTimer() { clearInterval(timerInterval); }

    // --- Pausar ---
    pauseBtn.onclick = () => {
        if (!recorder) return;
        if (recorder.state === "recording") {
            recorder.pause();
            toggleDeviceSelectors(true);
            stopTimer();
            if (indicator) indicator.querySelector('#indicatorText').textContent = 'Pausado';
            if (indicator) indicator.querySelector('.record-dot').style.animationPlayState = 'paused';
            if (typeof window._pauseRecordingOverlay === 'function') window._pauseRecordingOverlay();
            setVisibleButtons(resumeBtn, stopBtn);
        }
    };

    // --- Reanudar ---
    resumeBtn.onclick = () => {
        if (!recorder || recorder.state !== "paused") return;
        recorder.resume();
        toggleDeviceSelectors(true);
        if (indicator) indicator.querySelector('.record-dot').style.animationPlayState = 'running';
        if (typeof window._resumeRecordingOverlay === 'function') window._resumeRecordingOverlay();
        timerInterval = setInterval(() => {
            elapsedSeconds++;
            const m = String(Math.floor(elapsedSeconds / 60)).padStart(2, '0');
            const s = String(elapsedSeconds % 60).padStart(2, '0');
            if (indicatorTime) indicatorTime.textContent = `${m}:${s}`;
        }, 1000);
        setVisibleButtons(pauseBtn, stopBtn);
    };

    // --- Detener ---
    stopBtn.onclick = () => {
        if (recorder && recorder.state !== 'inactive') recorder.stop();
        toggleDeviceSelectors(false);
        clearInterval(timerInterval);

        // Limpiar animación del canvas
        if (window._canvasAnimationId) {
            cancelAnimationFrame(window._canvasAnimationId);
            delete window._canvasAnimationId;
        }

        if (indicator) indicator.style.display = 'none';
        if (typeof window._stopRecordingOverlay === 'function') window._stopRecordingOverlay();
    };

    // --- Cerrar ---
    closeBtn.onclick = () => {
        if (recorder && recorder.state !== 'inactive') recorder.stop();
        toggleDeviceSelectors(false);
        clearInterval(timerInterval);
        if (indicator) indicator.style.display = 'none';
        if (typeof window._stopRecordingOverlay === 'function') window._stopRecordingOverlay();
        if (typeof closeModal === 'function') closeModal();
    };

    // --- Volver a grabar ---
    redoBtn.onclick = () => {
        const stopAllTracks = s => {
            if (s && typeof s.getTracks === 'function') {
                s.getTracks().forEach(t => { if (t.readyState === 'live') t.stop(); });
            }
        };

        stopAllTracks(window._activeRecorderStream);
        stopAllTracks(window._canvasRecorderStream);
        toggleDeviceSelectors(false);
        // Limpiar animación
        if (window._canvasAnimationId) {
            cancelAnimationFrame(window._canvasAnimationId);
            delete window._canvasAnimationId;
        }

        // Limpiar canvas temporal
        if (window._finalCanvas) {
            delete window._finalCanvas;
        }

        blob = null;
        url = null;

        import('./recorderpreview.js').then(({ initPreview }) => {
            initPreview(type, previewArea, () => setupControls({
                type, modal, previewArea, onAttach,
                fpoptions, loadSelfieSegmentationLibs,
                uploadRecording, closeModal
            }));
        });
    };

    // --- Adjuntar al CKEditor (con loader) ---
    attachBtn.onclick = () => {
        if (!blob) return;
        attachBtn.disabled = true;
        const originalHTML = attachBtn.innerHTML;
        attachBtn.innerHTML = `
            <span class="loading-icon" style="display:inline-flex;align-items:center;gap:6px;">
                <i class="fas fa-spinner fa-spin"></i>
                Subiendo...
            </span>
        `;
        uploadRecording(blob, type, fpoptions, (url) => {
            attachBtn.innerHTML = originalHTML;
            attachBtn.disabled = false;
            onAttach(url);
            closeModal();
        }, (error) => {
            attachBtn.innerHTML = originalHTML;
            attachBtn.disabled = false;
            alert('Error al subir: ' + error);
        });
    };
}